// extracted by mini-css-extract-plugin
module.exports = {"container":"InstructionsDisplay_container__Vhlhx","header":"InstructionsDisplay_header__lZn9N","content":"InstructionsDisplay_content__qdtYn"};